enum ServiceType {
    TV = 'TV',
    INTERNET = 'INTERNET',
    VOIP = 'VOIP',
    XBOX_ALL_ACCESS = 'XBOX_ALL_ACCESS',
    TA_VOIP = 'TA_VOIP',
    FWA = 'FWA',
}

export { ServiceType };
